/**
 * Bookmark-safe redirect from legacy standalone admin routes into Pathway Studio panes (P5.5).
 */
import { Navigate, useLocation } from "react-router-dom";
import { legacyAdminPathToStudio } from "@/config/adminWorkflow";

export function StudioPaneRedirect() {
  const { pathname, search } = useLocation();
  const target = legacyAdminPathToStudio(pathname, search);
  return <Navigate to={target ?? "/app/admin/pathway-studio"} replace />;
}
